import * as URLConfig from "@frameworks/web/config/domain";
import { urlConstructor } from "@frameworks/web/config/domain";
var config = URLConfig.config;
var devs = config.kambalaBase;
var base = "transaction/";
var TOCJourneyConfigURL = {
    eq: config.kambalaSwitch
        ? config.jmwedel + devs + config.equity
        : config.jmw + config.eqedel,
    comm: config.kambalaSwitch
        ? config.jmwedel + devs + config.commodity
        : config.jmw + config.commedel,
    amo: "trade/amostatus/",
    multiquote: config.jmw + config.jmw_content + "quote/multiquote/v1",
    cancelAmoOrder: config.jmw + config.equity + "trade/amo/canceltrade",
    cancelPlaceOrder: config.jmw + config.equity + "trade/canceltrade",
    CoCancelPlaceOrder: config.jmw + config.commodity + "trade/canceltrade",
    CoCancelAmoOrder: config.jmw + config.commodity + "trade/amo/canceltrade",
    cancelEsipOrder: config.jmw + config.equity + "trade/cancelsip",
    modifyAmoOrder: config.jmw + config.equity + "trade/amo/modifytrade",
    modifyOrder: config.jmw + config.equity + "trade/modifytrade/v1",
    coModifyAmoOrder: config.jmw + config.commodity + "trade/amo/modifytrade",
    coModifyOrder: config.jmw + config.commodity + "trade/modifytrade",
    placeNormalTrade: config.jmwedel + devs + config.equity + "trade/placetrade/v1",
    orderDetails: config.jmwedel + devs + config.equity + "orderdetails/",
    orderDetailsComm: config.jmwedel + devs + config.commodity + "orderdetails/",
    checkMargin: config.jmwedel + devs + config.equity + "limits/checkmargin",
    brokerCharges: config.jmwedel + devs + config.equity + "trade/brokerage",
    rmsSubLimits: config.jmwedel + devs + config.equity + "limits/rmssublimits",
    rmsSubLimitsJusPay: config.jmwedel + config.jmw_payment + "eq-fund/rmssublimits",
    limits: config.jmwedel + devs + config.commodity + "limits",
    limitsJusPay: config.jmwedel + config.jmw_payment + "comm-fund/limits",
    tpin: config.jmwedel + devs + config.equity + "edis/tpin",
    amoTrade: config.jmwedel + devs + config.equity + "trade/amo/placetrade",
    bracketOrder: config.jmwedel + devs + config.equity + "trade/placebrackettrade/v1",
    esipOrder: config.jmwedel + devs + config.equity + "trade/placesip",
    authorize: config.jmwedel + devs + config.equity + "edis/authorize",
    brokerChargesComm: config.jmwedel + devs + config.commodity + "trade/brokerage",
    placeTradeComm: config.jmwedel + devs + config.commodity + "trade/placetrade",
    amoTradeComm: config.jmwedel + devs + config.commodity + "trade/amo/placetrade",
    PlaceOfsTrade: config.jmw + config.equity + "ofs/placetrade",
    upiList: config.jmw + config.edelmw_nse + "ipo/upilist",
    specificIPO: config.jmw + config.jmw_market_env + config.jmw_market + "ipo/specific",
    specificNcdIpoDetails: config.jmw + config.jmw_market_env + config.jmw_market + "ncd/details",
    ncdIpoSeries: config.jmw +
        config.jmw_market_env +
        config.jmw_market +
        "ncd/available-series",
    applyIPO: config.jmw + config.edelmw_nse + "ipo/apply",
    addClientDetailsNcd: config.jmw + config.jmw_conten_no_revamp + "ncdipo/addClientDetails",
    ncdIpoCheckPincode: config.jmw + config.jmw_conten_no_revamp + "ncdipo/checkPincode",
    validateUpi: config.jmw + config.edelmw_nse + "ipo/upi/validate",
    userStatus: config.jmw + config.edelmw_nse + "ipo/registration/status",
    ipoOtpLeads: config.jmwedel + config.jmw_content + "otp/leads",
    ipoBankMaster: config.jmwedel + config.jmw_conten_no_revamp + "admin/ipo/bank/master",
    asmGsmStatus: config.jmw + config.jmw_content + "quote/asmgsm/",
    exitAllBoOrder: config.jmwedel + devs + config.equity + "trade/exitbrackettrade/",
    ipoOtpValidate: config.jmwedel + config.jmw_content + "otp/validate/ipo",
    ipoOtpRegister: config.jmwedel + config.jmw_content + "otp/register/ipo",
    ipoCancel: config.jmwedel + config.edelmw_nse + "ipo/cancel",
    preApplyIPO: config.jmw + config.edelmw_nse + "ipo/apply/preorder",
    ncdipobankNames: config.jmwedel + config.jmw_conten_no_revamp + "ncdipo/bankName",
    ofsModifyTrade: config.jmw + config.equity + "ofs/modifytrade/",
    //MF apis
    MFPurchase: config.jmw +
        config.reportBase +
        config.appClient +
        "mf/getSchemeDetailsByCode",
    NfoPurchase: config.jmw +
        config.reportBase +
        config.appClient +
        "mf/getSchemeDetails/nfo",
    MFHolding: config.jmw + config.jmw_mf + "holding",
    rmsHolding: config.jmwedel + devs + config.equity + "holdings/v2/rmsholdings",
    sipFrequency: config.jmw + config.jmw_mf + "sip/freq",
    mfStartDate: urlConstructor(config.app_mf, "sip/", "start-date"),
    // mfStartDate: config.jmw + config.app_mf + "sip/start-date",
    // mfPurchaseOrder: config.jmw + config.app_mf + "trade/submit",
    // MFPurchaseNew: config.jmw + config.app_mf + base + "scheme-detail/v1",
    // mfSwitchDetail: `${config.jmw}${config.app_mf}${base}switch-detail`,
    // MFHoldingDetails: config.jmw + config.app_mf + base + "holding-detail/v1",
    // MFCancelOrder: config.jmw + config.app_mf + "modify-trade/cancel",
    // MFPauseResumeOrder: config.jmw + config.app_mf + "modify-trade/pause-resume",
    // mfModifyOrder: urlConstructor(config.app_mf, "modify-trade"),
    //encrypted Version
    mfPurchaseOrder: urlConstructor(config.app_mf, "trade/", "v1/submit"),
    // mfPurchaseOrder: config.jmw + config.app_mf + "trade/v1/submit",
    mfSwitchDetail: urlConstructor(config.app_mf, "transaction/", "v1/switch-detail"),
    // mfSwitchDetail: config.jmw + config.app_mf + "transaction/v1/switch-detail",
    MFHoldingDetails: urlConstructor(config.app_mf, "transaction/", "v1/holding-detail/v1"),
    // MFHoldingDetails:
    //   config.jmw + config.app_mf + "transaction/v1/holding-detail/v1",
    MFSchemeHoldingDetails: urlConstructor(config.app_mf, "transaction/", "scheme-holding-detail"),
    MFPurchaseNew: urlConstructor(config.app_mf, "transaction/", "v1/scheme-detail"),
    // MFPurchaseNew: config.jmw + config.app_mf + "transaction/v1/scheme-detail",
    MFCancelOrder: urlConstructor(config.app_mf, "modify-trade/", "v1/cancel"),
    // MFCancelOrder: config.jmw + config.app_mf + "modify-trade/v1/cancel",
    MFPauseResumeOrder: urlConstructor(config.app_mf, "modify-trade/", "v1/pause-resume"),
    // MFPauseResumeOrder:
    //   config.jmw + config.app_mf + "modify-trade/v1/pause-resume",
    mfSwitchDetailsFilters: urlConstructor(config.app_mf, "transaction/", "v1/switch-detail/filter"),
    mfModifyOrder: urlConstructor(config.app_mf, "modify-trade/v1"),
};
export default TOCJourneyConfigURL;
